import { ProjectDetailPage } from '@/pages/projects/ProjectDetailPage';
import { ROUTES } from '@/constants/routes';

export default function DevProjectDetailPage() {
  return <ProjectDetailPage source="dev" listRoute={ROUTES.DEV_PROJECTS} />;
}
